// test1746
(1746 && 0);
